/**
 * 응답 코드 배정 기준
 * 범위	용도	예시 코드
 * 20000~20099	가입 유도, 안내 등 정상 흐름	20001, 20002
 * 40000~40099	기타 클라이언트 오류	40003
 * 40300~40399	권한/상태 문제 (403류)	40301
 * 40100~40199	토큰 관련 인증 오류	40101 ~ 40103
 */
export var ApiResponseCode;
(function (ApiResponseCode) {
    /**
     * 가입되지 않은 소셜 계정
     *
     * 회원가입 유도 필요
     */
    ApiResponseCode[ApiResponseCode["SOCIAL_NOT_REGISTERED"] = 20001] = "SOCIAL_NOT_REGISTERED";
    /**
     * 소셜계정은 가입되지 않았지만 이메일 계정 등록되어 있음
     *
     * 계정 통합 안내 필요
     */
    ApiResponseCode[ApiResponseCode["SOCIAL_EXISTS_WITH_EMAIL"] = 20002] = "SOCIAL_EXISTS_WITH_EMAIL";
    /**
     * 비활성 회원
     *
     * 로그인 불가
     */
    ApiResponseCode[ApiResponseCode["USER_INACTIVE"] = 40301] = "USER_INACTIVE";
    /**
     * 소셜 인증 실패 (Provider 오류 등)
     */
    ApiResponseCode[ApiResponseCode["SOCIAL_AUTH_FAILED"] = 40003] = "SOCIAL_AUTH_FAILED";
    /**
     * JWT 토큰 만료
     */
    ApiResponseCode[ApiResponseCode["TOKEN_EXPIRED"] = 40101] = "TOKEN_EXPIRED";
    /**
     * JWT 토큰 무효 (서명 오류 등)
     */
    ApiResponseCode[ApiResponseCode["TOKEN_INVALID"] = 40102] = "TOKEN_INVALID";
    /**
     * JWT 토큰 없음 또는 블랙리스트 처리됨
     */
    ApiResponseCode[ApiResponseCode["TOKEN_MISSING"] = 40103] = "TOKEN_MISSING";
})(ApiResponseCode || (ApiResponseCode = {}));
